export default __webpack_public_path__ + "static/media/axisbank.a78ffbbe.webp";